import React from 'react'
import CloseIcon from 'assets/images/easyPay/close.svg'
import { useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <>
            <div className=" bg-transparent w-full px-4 h-14 flex items-center justify-between z-20">
                <span className="w-6" />
                <p className=" text-green-1 text-lg font-bold">{title}</p>
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    aria-label="بستن"
                    className=" -m-2.5 p-2.5 active:scale-90"
                >
                    <img src={CloseIcon} alt="" className=" w-6 h-6" />
                </button>
            </div>
        </>
    )
}
